import { HighlightStyle } from "@codemirror/language"
import { tags as t } from "@lezer/highlight"

export default HighlightStyle.define([
  { tag: t.heading1, class: "cm-markdoc-heading cm-markdoc-heading1" },
  { tag: t.heading2, class: "cm-markdoc-heading cm-markdoc-heading2" },
  { tag: t.heading3, class: "cm-markdoc-heading cm-markdoc-heading3" },
  { tag: t.heading4, class: "cm-markdoc-heading cm-markdoc-heading4" },
  { tag: t.heading5, class: "cm-markdoc-heading cm-markdoc-heading5" },
  { tag: t.heading6, class: "cm-markdoc-heading cm-markdoc-heading6" },
  { tag: t.strikethrough, class: "cm-markdoc-strikethrough" },
  { tag: t.emphasis, class: "cm-markdoc-emphasis" },
  { tag: t.strong, class: "cm-markdoc-emphasis-strong" },
  { tag: t.monospace, class: "cm-markdoc-inline-code" },
  { tag: t.link }, // configure in markdoc/decorations/link.js }
  { tag: t.list, class: "cm-markdoc-list-item" }
  // { tag: t.content, fontFamily: "sans-serif" },
  // { tag: t.meta, color: "darkgrey" },
])
